module.exports = __webpack_public_path__ + "img/will.d0d8befd.jpg";